var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"show-event"},[_c('v-row',[_c('span',{staticClass:"text-h5 ma-5 mb-0"},[_vm._v("Информация о бронировании")])]),_c('Event',{attrs:{"id":_vm.$route.params.id,"editable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }